var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { QuestionTypeName } from '../../learnware/LearnwareEnums';
import { clamp } from '../../../utils/helper/helper_math';
export class QuestionInfo {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get rating() {
        return this.question.floatRating / this.question.floatRateable;
    }
    get average() {
        let avg = this.question.floatReached / this.question.floatReachable;
        const currentTopicId = this.question.context.app.topic && this.question.context.app.topic.id_string;
        if (currentTopicId &&
            this.question.inTopic &&
            this.question.inTopic[currentTopicId] &&
            this.question.inTopic[currentTopicId].floatCount > 10) {
            avg = this.question.inTopic[currentTopicId].floatReached / this.question.inTopic[currentTopicId].floatReachable;
        }
        return clamp(avg, 0, 1);
    }
    get difficulty() {
        return 1 - this.average;
    }
    get tag() {
        return (this.question.subtopic && this.question.subtopic.name) || '';
    }
    get maxPoints() {
        return this.question.questionScore.maxPoints;
    }
    get isLegacyQuestion() {
        return [
            QuestionTypeName.MultipleChoice,
            QuestionTypeName.KnowAWord,
            QuestionTypeName.Associate,
            QuestionTypeName.MemorizePoints,
            QuestionTypeName.CorrectWrong
        ].includes(this.question.questionType);
    }
}
__decorate([
    computed
], QuestionInfo.prototype, "average", null);
__decorate([
    computed
], QuestionInfo.prototype, "tag", null);
__decorate([
    computed
], QuestionInfo.prototype, "maxPoints", null);
